import React, { useEffect, useState } from 'react';
import { getSolrData, useSolr } from '../../../hooks/useSolr';
import { useHistory } from 'react-router-dom';
import { detectLanguage } from '../../common/utils';
import { useInfiniteQuery } from 'react-query';

const TermGlossarySearchBox = () => {
    const history = useHistory();
    const bogusquery = 'nothing-to-search-for';
    const [query, setQuery] = useState(bogusquery);
    const [showSuggestions, setShowSuggestions] = useState(false);
    // console.log("query lang", detectLanguage(query));
    const queryfield = detectLanguage(query) === 'sa' ? 'name_deva' : `header`;

    const getSuggestions = async ({ pageParam }) => {
        // console.log('*** pg in getsuggestions', pageParam);
        if (!pageParam) {
            pageParam = 0;
        }
        const suggestionListQuery = {
            index: 'terms',
            params: {
                q: `${queryfield}:("${query}" OR ${query}*)`,
                fq: [
                    `tree:terms`,
                    '-associated_subject_ids:10524',
                    'ancestors_new.alpha:*',
                ],
                start: pageParam * 100,
                rows: 100,
                fl: '*',
                facet: false,
                sort: `score DESC, cascading_position_i ASC`,
            },
        };
        return getSolrData(suggestionListQuery, false);
    };

    const {
        data: suggestionData,
        error: suggestionError,
        fetchNextPage, // a comment here
        hasNextPage,
        isFetching,
        isFetchingNextPage,
        status,
    } = useInfiniteQuery({
        queryKey: ['suggestion-list', query],
        queryFn: getSuggestions,
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            // console.log('last page in get next', lastPage, pages);
            // console.log('returning', lastPage.start / 100 + 1);
            return lastPage.start / 100 + 1;
        },
    });

    /*
    const {
        isLoading: areSuggestionsLoading,
        data: suggestions,
        isError: isSuggestionsError,
        error: suggestionError,
    } = useSolr(['suggestion-list', query], suggestionListQuery, false, false);

     */

    const handleChange = (e) => {
        const value = e.target.value;
        setQuery(value);
        if (value) {
            setShowSuggestions(true);
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSelectSuggestion = (suggestion) => {
        setShowSuggestions(false);
        const tid = suggestion.uid.replace('terms-', '');
        history.push(`/terms/glossary/nod/${tid}`);
    };

    useEffect(() => {
        if (typeof query !== 'string' || query === '') {
            setQuery(bogusquery);
        }
    }, [query]);
    /*
    if (isSuggestionsError) {
        console.log('suggestion error', suggestionError);
    }*/
    // console.log('suggestionData', suggestionData, suggestionData?.pages);
    const numFound =
        suggestionData && suggestionData?.pages?.length > 0
            ? suggestionData.pages[0].numFound * 1
            : 0;
    const lastFound =
        suggestionData && suggestionData?.pages?.length > 0
            ? suggestionData.pages[suggestionData.pages.length - 1].start * 1 +
              100
            : 1;
    return (
        <div style={{ position: 'relative', width: '300px' }}>
            <input
                type="text"
                value={query !== bogusquery ? query : ''}
                onChange={handleChange}
                placeholder="Search..."
                className="gloss-search"
            />
            {numFound > 0 && (
                <ul className="suggestion-list">
                    {suggestionData?.pages.map((page, i) => (
                        <React.Fragment key={i}>
                            {page.docs.map((suggestion, di) => (
                                <li
                                    key={suggestion.uid}
                                    onClick={() =>
                                        handleSelectSuggestion(suggestion)
                                    }
                                    onMouseDown={(e) => e.preventDefault()} // Prevents input blur on click
                                >
                                    <span className="sa">
                                        {suggestion?.name_deva[0]}
                                    </span>{' '}
                                    <span className="font-times font-125">
                                        ({suggestion.header})
                                    </span>
                                </li>
                            ))}
                        </React.Fragment>
                    ))}
                    {numFound > lastFound && (
                        <li className="text-center">
                            <div>{numFound - lastFound} more entries</div>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    fetchNextPage();
                                    return false;
                                }}
                            >
                                {isFetchingNextPage
                                    ? 'Loading more...'
                                    : hasNextPage
                                    ? 'Load More'
                                    : 'Nothing more to load'}
                            </button>
                            {/* <div>
                                        Numfound: {suggestionData.pages[0].numFound} <br/>
                                        LastPage: {suggestionData.pages[suggestionData.pages.length - 1].start} <br/>
                                    </div> */}
                            <div>
                                {isFetching && !isFetchingNextPage
                                    ? 'Fetching...'
                                    : null}
                            </div>
                        </li>
                    )}
                </ul>
            )}
        </div>
    );
};

export default TermGlossarySearchBox;
